var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 87,
    viewBox: "0 0 91 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.775 0.274902C31.85 0.274902 17.745 8.9199 10.465 22.1149L0 11.6499V41.2249H29.575L16.835 28.4849C22.75 17.1099 34.125 9.3749 47.775 9.3749C66.43 9.3749 81.9 24.8449 81.9 43.4999C81.9 62.1549 66.43 77.6249 47.775 77.6249C32.76 77.6249 20.475 68.0699 15.47 54.8749H5.915C10.92 73.0749 27.755 86.7249 47.775 86.7249C71.89 86.7249 91 67.1599 91 43.4999C91 19.8399 71.435 0.274902 47.775 0.274902ZM40.95 23.0249V46.2299L62.335 58.9699L65.975 53.0549L47.775 42.1349V23.0249H40.95Z",
    fill: "#FF6900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.eca29d73.svg";
export { ForwardRef as ReactComponent };